import React from 'react';
import { AlertTriangle, RefreshCw, Trash2 } from 'lucide-react';

/**
 * Error Boundary do PDV — garante que a tela NUNCA fique em branco.
 * Se algum erro de renderização acontecer, mostra uma mensagem clara e
 * oferece recuperação: recarregar a página OU limpar o carrinho salvo
 * (que pode estar corrompido e causando o erro em loop) e recarregar.
 */
export class PDVErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: (error && error.message) || 'Erro inesperado' };
  }

  componentDidCatch(error, info) {
    // Log para diagnóstico (aparece no console do navegador)
    // eslint-disable-next-line no-console
    console.error('[PDV ErrorBoundary]', error, info);
  }

  clearCartAndReload = () => {
    try {
      Object.keys(localStorage)
        .filter((k) => k.startsWith('sf_pdv_cart_'))
        .forEach((k) => localStorage.removeItem(k));
    } catch (e) { /* ignore */ }
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4" data-testid="pdv-error-boundary">
        <div className="w-full max-w-md bg-white rounded-xl border border-slate-200 shadow-sm p-8 text-center">
          <div className="flex items-center justify-center h-14 w-14 rounded-full bg-red-50 text-red-600 mx-auto mb-4">
            <AlertTriangle className="h-7 w-7" />
          </div>
          <h1 className="text-2xl font-black text-slate-900 tracking-tight">Ops! O PDV encontrou um erro</h1>
          <p className="text-sm text-slate-500 mt-2">
            Não se preocupe: nenhuma venda finalizada foi perdida. Se a tela ficou travada, o carrinho atual pode estar com um item com problema. Use uma das opções abaixo para voltar a operar.
          </p>
          <div className="mt-6 flex flex-col gap-2">
            <button
              onClick={this.clearCartAndReload}
              data-testid="pdv-error-clear-cart"
              className="w-full inline-flex items-center justify-center gap-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 transition-colors active:scale-95"
            >
              <Trash2 className="h-4 w-4" /> Limpar carrinho e recarregar
            </button>
            <button
              onClick={() => window.location.reload()}
              data-testid="pdv-error-reload"
              className="w-full inline-flex items-center justify-center gap-2 rounded-md border border-slate-300 bg-white hover:bg-slate-50 text-slate-700 font-medium py-3 transition-colors"
            >
              <RefreshCw className="h-4 w-4" /> Apenas recarregar
            </button>
          </div>
          {this.state.message && (
            <p className="text-[11px] text-slate-400 mt-4 font-mono break-words">Detalhe técnico: {this.state.message}</p>
          )}
        </div>
      </div>
    );
  }
}
